import axios from 'axios';
import { unifiedDashboardAPIConfig } from 'src/utils/api-gateway/swo-ud-api-mappings';
import { MidwayAuth } from 'src/utils/auth/midway-auth';
import { getStage } from 'src/utils/env';

export interface QueryPanelDataInput {
  panelType: string;
  scopeType: string;
  /** Serialised `PanelFilterParams` — all ad-hoc filters for the panel. */
  filterParams?: string;
}

export interface QueryPanelDataOutput {
  panelType: string;
  data: string;
}

export class PanelDataService {
  private static readonly EXECUTE_API = 'execute-api';
  private static readonly HTTPS_PREFIX = 'https://';
  private static readonly PANEL_DATA_PATH = '/v0/panelData';

  private readonly endpoint: string;
  private readonly region: string;
  private readonly stagePath: string;

  constructor() {
    const config = unifiedDashboardAPIConfig(getStage());
    this.endpoint = config.endpoint;
    this.region = config.region;
    this.stagePath = config.stage;
  }

  async queryPanelData(input: QueryPanelDataInput): Promise<QueryPanelDataOutput> {
    const path = `/${this.stagePath}${PanelDataService.PANEL_DATA_PATH}`;
    const url = PanelDataService.HTTPS_PREFIX + this.endpoint + path;

    const request = {
      host: this.endpoint,
      url,
      data: input,
      body: JSON.stringify(input),
      method: 'POST',
      service: PanelDataService.EXECUTE_API,
      path,
      region: this.region,
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const signedRequest = await MidwayAuth.signRequest(request);
    const response = await axios(signedRequest);
    return response.data as QueryPanelDataOutput;
  }
}
